import React, {useState, useEffect} from 'react';
import {Row, Col, Container} from "react-bootstrap";
import axios from "axios";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import ReactPaginate from "react-paginate";

const OpenServiceOrders = () => {

    const [offset, setOffset] = useState(0);
    const [data, setData] = useState([]);
    const [perPage] = useState(10);
    const [pageCount, setPageCount] = useState(0)


    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    let redirect = ''
    if (userInfo) {
        if (userInfo.group === "AdminSuper") {
            redirect = '/inspections_dash'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_dash'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }


    const [resp, setClientData] = useState({ clients: null, preSites: null, onSite:null, proposal:null, invoices:null, workOrders:null, checklists:null, workHours:null, priority:null, comments:null});


    const fetchData = async () => {
        const clients = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/service_order_clients/`,{
            // `http://127.0.0.1:8000/api/service_order_clients/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
        );
        const service_orders = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/service_orders/`,{
            // `http://127.0.0.1:8000/api/service_orders/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
        );
        const soCLients = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/service_order_clients/`,{
            // `http://127.0.0.1:8000/api/service_order_clients/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
        );

        setClientData({
            pres: clients.data,
            ons: service_orders.data,
            prop: soCLients.data,
        });

        let activeClients = clients.data.map((client) => client.client)
        let activeServiceOrders = service_orders.data.map((client) => client.client)
        let activeSOClients = soCLients.data.map((client) => client.client)



        const data = clients.data;
        const slice = data.slice(offset, offset + perPage)
        const postData = slice.map(awo =>
            <div key={awo.id}>
                <Row
                    className={"workOrderRow"}
                >
                    <Col>
                        <Link className={'btn btn-primary'}
                              to={`/client_details/${awo.id}/`}>
                            {awo.work_site_address}
                        </Link>
                    </Col>

                    <Col className={"Col AddHourCol"}>
                        <Link className={'btn btn-warning'} to={`/clients/${awo.id}/add_service_order/`}>Create Service Order</Link>
                    </Col>

                    <Col className={"Col AddHourCol"}>
                        {
                            activeServiceOrders.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeServiceOrders.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'} to={`/admin_open_service_orders/${awo.id}/`}>
                                        Open Service Orders For Client
                                    </Link>)

                                    :
                                    ("Create Service Order For Job")
                                :
                                ("Create Service Order For Job")
                        }
                    </Col>
                </Row>
            </div>
        )
        setData(postData)
        setPageCount(Math.ceil(data.length / perPage))
    }
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        // setOffset(selectedPage + 1)
        setOffset(selectedPage * perPage)
    };


    useEffect(() => {
        fetchData();
    }, [offset]);

    // console.log('render');
    // if (resp.data) {
    //     console.log("d", resp.data, resp.pres, resp.ons, resp.prop, resp.inv, resp.workO, resp.cl, resp.hrs, resp.pri, resp.com);
    // }


    return (
        <Container fluid>

            <h1>Clients With Service Order Jobs:</h1>

            <div>
                {data}
                <ReactPaginate
                    previousLabel={"prev"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                />
            </div>
        </Container>
    )
}

export default OpenServiceOrders


// import React, {Component, useContext} from "react";
// import {Card, Col, Container, Nav, Row} from "react-bootstrap";
// import axios from "axios";
// import {Link} from "react-router-dom";
// import {ClockLoader} from "react-spinners";
// import ReactPaginate from 'react-paginate';
// import {useSelector} from "react-redux";
//
// //TODO: the refresh needs a timer on it. Otherwise it just runs all the time
// export class OpenServiceOrders extends Component {
//
//     constructor(props) {
//         super(props);
//         this.state = {
//             // Active Work Orders clients
//             AWOS: [],
//             clientIsLoading: true,
//
//             // Active Service Order clients
//             ASO: [],
//             service_orders_are_loading: true,
//             service_orders_are_loading2: true,
//
//             offset: 0,
//             data: [],
//             perPage: 10,
//             currentPage: 0
//         }
//         this.handlePageClick = this
//             .handlePageClick
//             .bind(this);
//
//     }
//
//     receivedData() {
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/service_order_clients/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({AWOS: response.data});
//                 this.setState({clientIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/service_orders/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({ASO: response.data});
//                 this.setState({service_orders_are_loading: false});
//             })
//
//         axios.get(`https://homesafetysolutions.pythonanywhere.com/api/service_order_clients/`)
//             .then(res => {
//                 this.setState({service_orders_are_loading2: false});
//                 const {
//                     AWOS,
//                     ASO,
//                 } = this.state;
//
//                 let activeServiceOrders = ASO.map((client) => client.client)
//
//                 const data = res.data;
//                 const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
//                 const postData = slice.map(pd =>
//                     <React.Fragment
//                         key={pd.work_site_address}
//                     >
//                         <Row
//                             className={"workOrderRow"}
//                         >
//                             <Col>
//                                 <Link className={'btn btn-primary'}
//                                       to={`/client_details/${pd.id}/`}>
//                                     {pd.work_site_address}
//                                 </Link>
//                             </Col>
//
//                             <Col className={"Col AddHourCol"}>
//                                 <Link className={'btn btn-warning'} to={`/clients/${pd.id}/add_service_order/`}>Create Service Order</Link>
//                             </Col>
//
//                             <Col className={"Col AddHourCol"}>
//                                 {
//                                     activeServiceOrders.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeServiceOrders.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'} to={`/admin_open_service_orders/${pd.id}/`}>
//                                                 Open Service Orders For Client
//                                             </Link>)
//
//                                             :
//                                             ("Create Service Order For Job")
//                                         :
//                                         ("Create Service Order For Job")
//                                 }
//                             </Col>
//
//                         </Row>
//                     </React.Fragment>)
//
//                 this.setState({
//                     pageCount: Math.ceil(data.length / this.state.perPage),
//
//                     postData
//                 })
//             });
//     }
//     handlePageClick = (e) => {
//         const selectedPage = e.selected;
//         const offset = selectedPage * this.state.perPage;
//
//         this.setState({
//             currentPage: selectedPage,
//             offset: offset
//         }, () => {
//             this.receivedData()
//         });
//
//     };
//
//     componentDidMount() {
//         this.receivedData()
//     }
//
//     render() {
//
//         const {
//             clientIsLoading,
//             service_orders_are_loading,
//             service_orders_are_loading2,
//
//         } = this.state;
//
//
//         if (clientIsLoading || service_orders_are_loading || service_orders_are_loading2) {
//             return <div className={'loadingSpinner'}>Loading...<br/> <ClockLoader color={'#0d00ff'}/></div>
//         }
//
//
//         return (
//
//             <Container fluid>
//
//                 <h1>Clients With Service Order Jobs:</h1>
//
//                 <div>
//                     {this.state.postData}
//                     <ReactPaginate
//                         previousLabel={"prev"}
//                         nextLabel={"next"}
//                         breakLabel={"..."}
//                         breakClassName={"break-me"}
//                         pageCount={this.state.pageCount}
//                         marginPagesDisplayed={2}
//                         pageRangeDisplayed={5}
//                         onPageChange={this.handlePageClick}
//                         containerClassName={"pagination"}
//                         subContainerClassName={"pages pagination"}
//                         activeClassName={"active"}/>
//                 </div>
//             </Container>
//         );
//     }
// }
//
// export default OpenServiceOrders;
//
//
// // import React, {Component, useEffect, useState} from "react";
// // import {Col, Row} from "react-bootstrap";
// // import axios from "axios";
// // import {Link} from "react-router-dom";
// //
// // import {ClockLoader} from "react-spinners";
// //
// //
// //
// // //TODO: the refresh needs a timer on it. Otherwise it just runs all the time
// //
// // export class OpenServiceOrders extends Component {
// //
// //     constructor(props) {
// //         super(props);
// //         this.state = {
// //             // Active Work Orders clients
// //             AWOS: [],
// //             clientIsLoading: true,
// //
// //             // Active Service Order clients
// //             ASO: [],
// //             service_orders_are_loading: true,
// //         }
// //     }
// //
// //
// //     componentDidMount() {
// //         axios.get('https://homesafetysolutions.pythonanywhere.com/api/service_order_clients/', {
// //             headers: {
// //                 "Accept": 'application/json',
// //                 "Content-Type": 'application/json'
// //             },
// //         })
// //             .then(response => {
// //                 this.setState({AWOS: response.data});
// //                 this.setState({clientIsLoading: false});
// //             })
// //
// //         axios.get('https://homesafetysolutions.pythonanywhere.com/api/service_orders/', {
// //             headers: {
// //                 "Accept": 'application/json',
// //                 "Content-Type": 'application/json'
// //             },
// //         })
// //             .then(response => {
// //                 this.setState({ASO: response.data});
// //                 this.setState({service_orders_are_loading: false});
// //             })
// //     };
// //
// //     render() {
// //
// //         const {
// //             AWOS,
// //             ASO,
// //             clientIsLoading,
// //             service_orders_are_loading,
// //         } = this.state;
// //
// //         if (clientIsLoading || service_orders_are_loading) {
// //             return <div className={'loadingSpinner'}>Loading...<br/> <ClockLoader color={'#0d00ff'}/></div>
// //         }
// //
// //         let activeServiceOrders = ASO.map((client) => client.client)
// //
// //         return (
// //             <div>
// //                 <h1>Clients With Service Order Jobs:</h1>
// //                 {AWOS.map((awo, index) =>
// //                     <Row
// //                         key={awo.work_site_address}
// //                         index={index}
// //                         className={"workOrderRow"}
// //                     >
// //                         <Col>
// //                             <Link className={'btn btn-primary'}
// //                                   to={`/client_details/${awo.id}/`}>
// //                                 {awo.work_site_address}
// //                             </Link>
// //                         </Col>
// //
// //                         <Col className={"Col AddHourCol"}>
// //                             <Link className={'btn btn-warning'} to={`/clients/${awo.id}/add_service_order/`}>Create Service Order</Link>
// //                         </Col>
// //
// //                         <Col className={"Col AddHourCol"}>
// //                             {
// //                                 activeServiceOrders.includes(awo.id)
// //                                     ?
// //                                     ('So True')
// //                                     &&
// //                                     activeServiceOrders.includes(awo.id)
// //                                         ?
// //                                         (<Link className={'btn btn-info'} to={`/admin_open_service_orders/${awo.id}/`}>
// //                                             Open Service Orders For Client
// //                                         </Link>)
// //
// //                                         :
// //                                         ("Create Service Order For Job")
// //                                     :
// //                                     ("Create Service Order For Job")
// //                             }
// //                         </Col>
// //
// //                     </Row>
// //                 )}
// //             </div>
// //         );
// //     }
// // }
// //
// // export default OpenServiceOrders;
//
